/**
 * @generated SignedSource<<c0ccaaf3a4baf999dcdd44bd5127d2ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PLACEMENT_OF_TASK = "TOP" | "BOTTOM" | "%future added value";
export type CreateTaskInput = {
  projectId?: string | null;
  parentId?: string | null;
  name?: string | null;
  phaseId?: string | null;
  sprintId?: string | null;
  placementOfTask?: PLACEMENT_OF_TASK | null;
  underTaskId?: string | null;
  description?: string | null;
  estimateLow?: number | null;
  estimateHigh?: number | null;
  forecast?: number | null;
  timeLeft?: number | null;
  approved?: boolean | null;
  deadlineYear?: number | null;
  deadlineMonth?: number | null;
  deadlineDay?: number | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  roleId?: string | null;
  assignedPersons?: ReadonlyArray<string | null> | null;
  labels?: ReadonlyArray<string | null> | null;
  statusColumnId?: string | null;
  highPriority?: boolean | null;
  ownerId?: string | null;
  parentTaskId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createForecastTaskMutation$variables = {
  input: CreateTaskInput;
};
export type createForecastTaskMutation$data = {
  readonly createTask: {
    readonly task: {
      readonly node: {
        readonly id: string;
        readonly companyTaskId: number | null;
        readonly name: string | null;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type createForecastTaskMutation = {
  variables: createForecastTaskMutation$variables;
  response: createForecastTaskMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTaskPayload",
    "kind": "LinkedField",
    "name": "createTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskTypeEdge",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyTaskId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createForecastTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createForecastTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0be986e6a46faedf45a1c1179824318e",
    "id": null,
    "metadata": {},
    "name": "createForecastTaskMutation",
    "operationKind": "mutation",
    "text": "mutation createForecastTaskMutation(\n  $input: CreateTaskInput!\n) {\n  createTask(input: $input) {\n    task {\n      node {\n        id\n        companyTaskId\n        name\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c7ae4d8e75d546b4df9c8bfac798410";

export default node;
